
import $ from 'jquery';
import RMTween from 'rmlibrary/tween';
import { findFocusable } from 'rmlibrary/dom-helpers';

var resizeHandlers = [];

var TouchEvent = window.TouchEvent || function () {};

function getX(event) {
    event = event.originalEvent || event;
    if (event instanceof TouchEvent) {
        return event.touches[0].pageX;
    } else {
        return event.pageX;
    }
}
function getY(event) {
    event = event.originalEvent || event;
    if (event instanceof TouchEvent) {
        return event.touches[0].pageY;
    } else {
        return event.pageY;
    }
}

var SlideProxy = function SlideProxy(el, slidesUp, isVertical) {
    this.el = el;
    this.isVertical = isVertical;
    this.m = slidesUp ? 1 / slidesUp : 0;
    this._position;
};

var prototypeAccessors = { position: { configurable: true } };

prototypeAccessors.position.set = function (v) {
    var percent = v * this.m;
    this._position = v;
    if (this.isVertical) {
        this.el.css({
            "-webkit-transform": ("translate(0, " + (percent * 100) + "%)"),
            "transform": ("translate(0, " + (percent * 100) + "%)")
        });
    } else {
        this.el.css({
            "-webkit-transform": ("translate(" + (percent * 100) + "%, 0)"),
            "transform": ("translate(" + (percent * 100) + "%, 0)")
        });
    }
};
prototypeAccessors.position.get = function () {
    return this._position;
};

Object.defineProperties( SlideProxy.prototype, prototypeAccessors );

var initialized = false;
function initResizeHandlers() {
    if (initialized) { return; }
    initialized = true;

    var windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    function resizeHandler() {
        var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (w !== windowWidth) {
            resizeHandlers.forEach(function (fn) { return fn(); });
        }
    }
    $(window).resize(resizeHandler);
    window.setInterval(resizeHandler, 500);
}

export var Carousel = function Carousel(el) {
    var this$1 = this;

    initResizeHandlers();

    this.element = el = $(el);
    this.listElement = el.find('.js-carousel-list');
    this.slides = this.listElement.find('.js-carousel-member').detach();

    this.resizeHandlerWrapper = this.resizeHandlerWrapper.bind(this);
    this.slidePrev = this.slidePrev.bind(this);
    this.slideNext = this.slideNext.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);

    el.find(".js-prev-btn").click(this.slidePrev)
    el.find(".js-next-btn").click(this.slideNext)
    this.listElement.on('mousedown touchstart', this.handleMouseDown);


    this._position = 0;
    this._queue = [];

    resizeHandlers.push(this.resizeHandlerWrapper);

    this.isVertical = false;

    this.init();

    this.element.attr({
        'role': 'group',
        'aria-roledescription': 'carousel'
    });
    // this.listElement.attr({
    // "aria-live": "polite"
    // });

    this.slides.each(function (i, el) {
        $(el).attr({
            'role': 'group',
            'aria-roledescription': 'slide',
            'aria-label': ((i + 1) + " of " + (this$1.slides.length))
        })
    })
        
    if (!this._slidesUp || this._slidesUp < 1) {
        this.slidesUp = 1;
    }
};

var prototypeAccessors$1 = { position: { configurable: true },slidesUp: { configurable: true } };

Carousel.prototype.init = function init () {
    // Do nothing
};

prototypeAccessors$1.position.get = function () {
    return this._position;
};
prototypeAccessors$1.position.set = function (v) {
    if (this._isDragging) { return; }
    this.cancelDrag();
    this.cancelAnimation(false);
    var oldPosition = this._position;
    this._position = this._normalizePosition(v);
    if (this._position !== oldPosition) { this.updateAfterAnimation(this._position); }
};

Carousel.prototype._normalizePosition = function _normalizePosition (v) {
    var newPosition = v % this.slides.length;
    if (newPosition < 0) { newPosition += this.slides.length; }
    return newPosition;
};

Carousel.prototype._getSlides = function _getSlides (start, num) {
        var this$1 = this;

    start = this._normalizePosition(start);
    var slideIndexes = [];
    for (var i = 0; i < num; i++) { slideIndexes.push((start + i) % this$1.slides.length); }
    var slides = $(slideIndexes.map(function (i) { return this$1.slides[i]; })).clone();
    return slides;
};

Carousel.prototype.updateAfterAnimation = function updateAfterAnimation (position) {
        var this$1 = this;

    var slidesUp = this.slidesUp;
    var previous = $(("<div aria-hidden=\"true\" class=\"" + (this.screenClass || '') + " " + (this.screenClassPrev || '') + "\">")).append(this._getSlides(position - slidesUp, slidesUp));

    $(findFocusable(previous[0], true)).attr('tabindex', '-1');
    var current = $(("<div class=\"" + (this.screenClass || '') + "\">")).attr("aria-live", "polite").append(this._getSlides(position, slidesUp));
    var next = $(("<div aria-hidden=\"true\" class=\"" + (this.screenClass || '') + " " + (this.screenClassNext || '') + "\">")).append(this._getSlides(position + slidesUp, slidesUp));
    $(findFocusable(next[0], true)).attr('tabindex', '-1');
    var sectionContainer = $("<div>").append(previous).append(current).append(next);
    this.tweenEl = new SlideProxy(sectionContainer, this.slidesUp, this.isVertical);
    this.listElement.empty().append(sectionContainer);

    setTimeout(function () {
        current.empty().append(this$1._getSlides(position, slidesUp));
    }, 0)
};

Carousel.prototype.resizeHandlerWrapper = function resizeHandlerWrapper () {
        var this$1 = this;

    if (this.isVertical) {
        this.slideSize = this.listElement[0].getBoundingClientRect().height / this.slidesUp;
    } else {
        this.slideSize = this.listElement[0].getBoundingClientRect().width / this.slidesUp;
    }
    // Timeout is required when maximize button is used.
    window.setTimeout(function () {
        if (this$1.isVertical) {
            this$1.slideSize = this$1.listElement[0].getBoundingClientRect().height / this$1.slidesUp;
        } else {
            this$1.slideSize = this$1.listElement[0].getBoundingClientRect().width / this$1.slidesUp;
        }
    }, 500);
};

prototypeAccessors$1.slidesUp.get = function () {
    return this._slidesUp;
};

prototypeAccessors$1.slidesUp.set = function (v) {
    var oldSlidesUp = this._slidesUp;
    this._slidesUp = v;

    if (oldSlidesUp !== this.slidesUp) {
        if (this.slides.length <= this.slidesUp) {
            this.isStatic = true;
            this.element.addClass("is-static");
            var allSlides = $(("<div class=\"" + (this.screenClass || '') + "\">")).append(this.slides.clone());
            this.listElement.empty().append(allSlides);
        } else {
            this.isStatic = false;
            this.element.removeClass("is-static");
            this.updateAfterAnimation(this.position);
        }
    }

    this.resizeHandlerWrapper();
};

Carousel.prototype.resizeHandler = function resizeHandler () {
    // Do nothing
};

Carousel.prototype.cancelAnimation = function cancelAnimation () {
    this._queue = [];
    if (this._tween) {
        this._tween.stop();
        this._tween = null;
    }
};

Carousel.prototype.enqueue = function enqueue (fn) {
    this._queue = this._queue.concat( [fn]
    );
    if (!this._tween) { this.dequeue(); }
};

Carousel.prototype.dequeue = function dequeue () {
    if (this._queue && this._queue.length) {
        var ref = this._queue;
            var fn = ref[0];
            var rest = ref.slice(1);
        this._queue = rest;
        fn();
    }
};

Carousel.prototype.slideAnimation = function slideAnimation (from, to, speed, easing) {
        var this$1 = this;
        if ( speed === void 0 ) speed = 250;
        if ( easing === void 0 ) easing = 'easeInOut';

    var t = (this._queue.length || this._tween ? 0.6 : 1) * speed; // Animation will be faster if one is already playing
    var runFn = function () {
        var newPosition = this$1._normalizePosition(this$1.position + to);
        var oldPosition = this$1._position;
        this$1._position = newPosition;
        this$1._tween = RMTween.create(this$1.tweenEl)
        .to({position: from * -1}, 0)
        .to({position: to * -1}, t, easing)
        .run(function () {
            if (this$1._position !== oldPosition) { this$1.updateAfterAnimation(newPosition); }
            this$1._tween = null;
            this$1.dequeue();
        })

    }
    this.enqueue(runFn);
};

Carousel.prototype.slidePrev = function slidePrev () {
    this.slideAnimation(0, -1);
};
Carousel.prototype.slideNext = function slideNext () {
    this.slideAnimation(0, 1);
};

Carousel.prototype.handleMouseDown = function handleMouseDown (e) {
    if (this.isStatic) { return; }

    this._startX = this.isVertical ? getY(e) : getX(e);
    this._startY = this.isVertical ? getX(e) : getY(e);
    this._dragX = 0;
    this._vx = 0;
    this._t = Date.now();

    document.addEventListener('mousemove', this.handleMouseMove, {passive:false});
    document.addEventListener('touchmove', this.handleMouseMove, {passive:false});
    document.addEventListener('mouseup', this.handleMouseUp, true);
    document.addEventListener('touchend', this.handleMouseUp, {passive:false});
    document.addEventListener('touchcancel', this.handleMouseUp, {passive:false});
};

Carousel.prototype.cancelDrag = function cancelDrag () {
    this._isDragging = false;
    this._startX = null;
    this._startY = null;
    this._dragX = null;
    this._vx = null;
    document.removeEventListener('mousemove', this.handleMouseMove, {passive:false});
    document.removeEventListener('touchmove', this.handleMouseMove, {passive:false});
    document.removeEventListener('mouseup', this.handleMouseUp, true);
    document.removeEventListener('touchend', this.handleMouseUp, {passive:false});
    document.removeEventListener('touchcancel', this.handleMouseUp, {passive:false});
};

Carousel.prototype.handleMouseUp = function handleMouseUp (e) {
    if (this._isDragging) { e.preventDefault(); }
    var dx = this._dragX;
    var vx = this._vx;
    var a = -vx / 100;
    var at = 200;
    var endX = (vx * at) + (a * at * 50) + dx;
    this.cancelDrag();

    var from = dx / this.slideSize;
    var to = endX / this.slideSize;
    if (to < -this.slidesUp) {
        to = -this.slidesUp;
    }
    if (to > this.slidesUp) {
        to = this.slidesUp;
    }
    to = Math.round(to);
    this.slideAnimation(-from, -to, 100, 'easeOut');
};

Carousel.prototype.handleMouseMove = function handleMouseMove (e) {
    var x = this.isVertical ? getY(e) : getX(e);
    var y = this.isVertical ? getX(e) : getY(e);
    var dx = x - this._startX;
    var dy = Math.abs(y - this._startY);
    var t = Date.now();
    var dt = t - this._t;
    var vx = (dx - this._dragX) / dt;

    if (!this._isDragging) {
        if (dy > Math.abs(dx)) {
            this.cancelDrag();
            return;
        }
    }
    e.preventDefault();
    this._isDragging = true;
    this._dragX = dx;
    this._t = t;
    this._vx = vx;

    this.tweenEl.position = dx / this.slideSize;
};

Object.defineProperties( Carousel.prototype, prototypeAccessors$1 );